import { useLocation, useParams, useSearchParams } from 'react-router-dom'

import { isTokenInvalidOrAbsent } from 'src/views/pages/login/ProtectedRoute'
import { PublicComponentEventBooking, SecuredComponentEventBooking } from './BookingComponents'

export default function EventBooking({ openedAsWebview }) {
  //plan : event public pages :

  // for unsecured : three api calls : mentor details, booked slots unsecured call, and one on one subscription plan details
  // for secured : three calls : secured setup call, booked slots secured call, and profile data call (these may also be passed)
  // accomodate : fromOnboarding flag from useLocation and on last page after booking, take user to complete onboarding

  const { mentorSlug, eventId } = useParams()

  const [searchParams] = useSearchParams()
  const date = searchParams.get('date')
  const tgt = searchParams.get('tgt')
  const tlt = searchParams.get('tlt')

  const { state } = useLocation()
  let fromOnboarding = state?.fromOnboarding
  let selectedTimeSlotIndex = state?.redirectData?.selectedTimeSlotIndex
  let selectedDateValue = state?.redirectData?.selectedDateValue

  let addictionFormData = state?.addictionFormData

  const token = localStorage.getItem('token')

  if (isTokenInvalidOrAbsent(token)) {
    return (
      <>
        <PublicComponentEventBooking
          eventId={eventId}
          mentorSlug={mentorSlug}
          openedAsWebview={openedAsWebview}
          addictionFormData={addictionFormData}
          date={date}
          tgt={tgt}
          tlt={tlt}
        />
      </>
    )
  } else {
    return (
      <SecuredComponentEventBooking
        fromOnboarding={fromOnboarding}
        mentorSlug={mentorSlug}
        eventId={eventId}
        pastSelectedTimeSlotIndex={selectedTimeSlotIndex}
        pastSelectedDateValue={selectedDateValue}
        openedAsWebview={openedAsWebview}
        addictionFormData={addictionFormData}
        date={date}
        tgt={tgt}
        tlt={tlt}
      />
    )
  }
}
